import { Injectable } from "@angular/core";

import { AttachmentsDialogService, DocumentService } from "@tylertech/attachments-module";
import
{
    IAggregate,
    ICardAction,
    ICardData,
    DocumentSearchCriteria,
    ActionType,
} from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";
import { AggregateActionResult } from "../services";

// TODO - why does this live here and not in library/attachments
@Injectable()
export class AttachmentActionHandler implements IAggregateActionHandler
{
    constructor(
        private $attachmentsDialogService: AttachmentsDialogService,
        private $documentApiService: DocumentService,
    ) { }

    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Attachments;
    }

    execute(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        return this.openDialog(cardData.Id, action.content).then(_x =>
        {
            this.getCount(cardData.Id, action);
            return false;
        });
    }

    openDialog(id: string, entityType: string): Promise<unknown>
    {
        return this.$attachmentsDialogService.show(id, entityType, false, null, null, false);
    }

    getCount(id: string, action: ICardAction): void
    {
        const criteria = <DocumentSearchCriteria>{
            EntityId: id,
            EntityType: action.content,
        };
        this.$documentApiService.GetDocumentCount(criteria).then(result =>
        {
            action.Model = result.Result;
        });
    }

    load(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): void
    {
        this.getCount(cardData.Id, action);
    }
}
